import {register} from '@shopify/theme-sections';
import Modal from '../components/modal';
import {setCookie} from '../helpers/cookies';

// This will only visible on pages that
// include `/?customer_posted=true` in the URL
const selectors = {
  target: 'modal--',
};

register('signup-success', {
  onLoad() {
    const target = `.${selectors.target}${this.id}`;
    const modal = document.querySelector(target);
    this.target = target;
    this.modal = modal;

    if(!this.modal) {return}

    this.init();
  },

  init() {
    this.contactSubmitted();
  },

  createModal() {
    Modal(this.target).init();
  },

  // URL Contains /?customer_posted=true
  contactSubmitted() {
    const name = 'customer_posted'
    const results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);

    if (results === null) { return; }

    const resultsSplit = results[1] || 0;

    if (resultsSplit === 'true') {
      this.createModal();
      this.open();
      setCookie('sign_up', 'closed', 340);
    }
  },

  open() {
    Modal(this.target, {bodyLock: false}).modalOpen();

    window.setTimeout(() => {
      Modal(this.target).modalClose();
    }, 7000);
  },

  onSelect: () => {
    Modal(this.target, {bodyLock: false}).modalOpen();

    console.log(`👷‍♀️ Modal: Let's build!`);
  },

  onDeselect: () => {
    Modal(this.target, {bodyLock: false}).closeModal();

    console.log(`👋 Modal: Thanks for everything!`);
  },
});
